import { PageLabelFunctions } from '../types';
import { requestToVaryDeclaration } from './requestToVaryDeclaration';

export const RequestToVary: PageLabelFunctions = {
    requestToVaryDeclaration,
};
